import React, { useState, useEffect } from "react";
import useProducts from "./hooks/useProducts";
import ProductGrid from "./components/ProductGrid";
import FilterSidebar from "./components/FilterSidebar";
import FilterChips from "./components/FilterChips";
import SearchBar from "./components/SearchBar";
import ContactInfo from "./components/ContactInfo";
import ProductSelector from "./components/ProductSelector";
import ProductLightbox from "./components/ProductLightbox";
import { getDataConfig } from "./config";
import BackToTop from "./components/BackToTop";
import "./App.css";

// const CSV_URL = process.env.PUBLIC_URL + "/productos.csv";
// Usar la URL del CSV desde la configuración
const config = getDataConfig();
const CSV_URL = config.csv;

function App() {
  const {
    products,
    loading,
    error,
    categories,
    selectedCategory,
    setSelectedCategory,
    searchTerm,
    setSearchTerm,
  } = useProducts(CSV_URL);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [lightboxProduct, setLightboxProduct] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelectProduct = (product) => {
    setSelectedProducts((prev) => {
      const existing = prev.find((p) => p.codigo === product.codigo);
      if (existing) {
        return prev.map((p) =>
          p.codigo === product.codigo ? { ...p, quantity: p.quantity + 1 } : p,
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const handleRemoveProduct = (codigo, quantity = 1) => {
    setSelectedProducts((prev) => {
      const existing = prev.find((p) => p.codigo === codigo);
      if (existing.quantity > quantity) {
        return prev.map((p) =>
          p.codigo === codigo ? { ...p, quantity: p.quantity - quantity } : p,
        );
      }
      return prev.filter((p) => p.codigo !== codigo);
    });
  };

  useEffect(() => {
    document.title = "Mi Catálogo Online - Tiendas EMA";
  }, []);

  return (
    <div className="app">
      <header className="app-header">
        <h1>Tiendas EMA</h1>
        <h2>||--Catálogo de Productos--||</h2>
        <p>Tu tienda de confianza....</p>
      </header>

      <div className="app-content">
        {!isMobile && (
          <aside className="sidebar">
            <FilterSidebar
              categories={categories}
              selectedCategory={selectedCategory}
              onCategoryChange={setSelectedCategory}
            />
          </aside>
        )}

        <main className="main-content">
          <ContactInfo />
          <SearchBar searchTerm={searchTerm} onSearchChange={setSearchTerm} />

          {isMobile && (
            <FilterChips
              categories={categories}
              selectedCategory={selectedCategory}
              onCategoryChange={setSelectedCategory}
            />
          )}

          {error && <div className="error-message">{error}</div>}

          {selectedCategory !== "Todas" && (
            <div className="active-filter">
              Filtrado por: <strong>{selectedCategory}</strong>
              <button onClick={() => setSelectedCategory("Todas")}>
                ✕ Limpiar filtro
              </button>
            </div>
          )}

          <ProductGrid
            products={products}
            loading={loading}
            onSelectProduct={handleSelectProduct}
            onOpenLightbox={setLightboxProduct}
          />

          <div className="product-count">
            Mostrando {products.length} productos
          </div>
        </main>
      </div>

      <ProductSelector
        products={products}
        selectedProducts={selectedProducts}
        onSelectProduct={handleSelectProduct}
        onRemoveProduct={handleRemoveProduct}
      />

      {lightboxProduct && (
        <ProductLightbox
          product={lightboxProduct}
          onClose={() => setLightboxProduct(null)}
          onAddToCart={handleSelectProduct}
        />
      )}
      <BackToTop />
    </div>
  );
}

export default App;
